import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetRole = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['type'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if(is_paginate==1){
        params['paginate'] = is_paginate;
    }


    const response = await GET(apiUrl.role, params);
    return response;
}

export const GetRoleById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.role + '/' + id,params);
    return response;
}

export const CreateRole = async (data) => {
    const response = await POST(apiUrl.role, data);
    return response;
}

export const UpdateRole = async (id, data) => {
    const response = await PUT(apiUrl.role, id, data);
    return response;
}

export const DeleteRole = async (id) => {
    const response = await DELETE(apiUrl.role, id);
    return response;
}
